import { useDispatch, useSelector } from "react-redux";
import { fetchMembers } from '../fetch/search.js';
import { selectLangObj } from "../reducers/langReducer.js";
import { useEffect } from "react";

import { useParams } from 'react-router';
import GridType, { GridTypeMap } from '../models/GridType.ts';
import MembersPagination from "../components/paginations/MembersPagination.js";

function Members({title}) {
    const dispatch = useDispatch();


    const {id} = useParams();


  
    useEffect(() => {
        dispatch(fetchMembers({param:id, page:0}));

    }, []);


    return (

        <div className="h-full w-full p-3 flex flex-col  items-center justify-center">
        <div className="md:w-2/3 max-md:self-stretch rounded-xl flex-grow min-h-0 flex flex-col  items-center justify-center backdrop-blur-md bg-slate-500 bg-opacity-50">
            <div className="text-3xl text-white text-left mt-3 mb-5">
                {title}
            </div>
            <div className="flex-grow min-h-0">

            <MembersPagination term={id}></MembersPagination>
            </div>
        </div>
        </div>





    )
}
export default Members;